import React from 'react';
import PropTypes from 'prop-types';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import DemographicsLocationTable from
  'dyzio-shared-components/lib/components/demographics-location-table';

const FullCountryModal = ({
  onToggle,
  audienceLocations,
}) =>
  <DyzioModal
    headerText="Fans by Country"
    size="small"
    onClose={onToggle}
    hasCloseButton
  >
    <DemographicsLocationTable
      data={audienceLocations.data}
      metric="absolute"
      metricLabel="Fans"
      itemLabel="Country"
      rowsToShow={-1}
    />
  </DyzioModal>;

FullCountryModal.propTypes = {
  onToggle: PropTypes.func.isRequired,
  audienceLocations: PropTypes.object.isRequired,
};

export default FullCountryModal;



/** WEBPACK FOOTER **
 ** ./src/components/facebook-profile-data-large/full-country-modal.js
 **/